export const fontFaceList = [
  {
    name: 'Arial',
    value: 'Arial, sans-serif',
    original: true
  },
  {
    name: 'Courier New',
    value: 'Courier New, monospace',
    original: true
  },
  {
    name: 'Georgia',
    value: 'Georgia, serif',
    original: true
  },
  {
    name: 'Times New Roman',
    value: 'Times New Roman, serif',
    original: true
  },
  {
    name: 'Trebuchet MS',
    value: 'Trebuchet MS, sans-serif',
    original: true
  },
  {
    name: 'Verdana',
    value: 'Verdana, sans-serif',
    original: true
  },
  {
    name: 'AbrilFatface',
    value: 'CartxAbrilFatface',
    original: false
  },
  {
    name: 'Antonio',
    value: 'CartxAntonio',
    original: false
  },
  {
    name: 'Atkinson-Hyperlegible-Bold-Italic-102',
    value: 'CartxAtkinsonHyperlegibleBoldItalic102',
    original: false
  },
  {
    name: 'DancingScript',
    value: 'CartxDancingScript',
    original: false
  },
  {
    name: 'DellaRespira',
    value: 'CartxDellaRespira',
    original: false
  },
  {
    name: 'Dosis',
    value: 'CartxDosis',
    original: false
  },
  {
    name: 'Helvetica',
    value: 'CartxHelvetica',
    original: false
  },
  {
    name: 'LDFComicSans',
    value: 'CartxLDFComicSans',
    original: false
  },
  {
    name: 'LobsterTwo',
    value: 'CartxLobsterTwo',
    original: false
  },
  {
    name: 'Lovelo',
    value: 'CartxLovelo',
    original: false
  },
  {
    name: 'Morganite',
    value: 'CartxMorganite',
    original: false
  },
  {
    name: 'NotCourierSans',
    value: 'CartxNotCourierSans',
    original: false
  },
  {
    name: 'NoticiaTextItalic',
    value: 'CartxNoticiaTextItalic',
    original: false
  },
  {
    name: 'PermianSansTypeface',
    value: 'CartxPermianSansTypeface',
    original: false
  },
  {
    name: 'Promesh',
    value: 'CartxPromesh',
    original: false
  },
  {
    name: 'Roboto',
    value: 'CartxRoboto',
    original: false
  },
  {
    name: 'Rubik',
    value: 'CartxRubik',
    original: false
  },
  {
    name: 'SyncopateRegular',
    value: 'CartxSyncopateRegular',
    original: false
  },
  {
    name: 'Vnantiq',
    value: 'CartxVnantiq',
    original: false
  },
  {
    name: 'Zaio',
    value: 'CartxZaio',
    original: false
  },
  {
    name: 'AlegreyaSans-Bold',
    value: 'CartxAlegreyaSansBold',
    original: false
  },
  {
    name: 'AlegreyaSans-Medium',
    value: 'CartxAlegreyaSansMedium',
    original: false
  },
  {
    name: 'AlegreyaSansSC-ExtraBold',
    value: 'CartxAlegreyaSansSCExtraBold',
    original: false
  },
  {
    name: 'DidactGothic',
    value: 'CartxDidactGothic',
    original: false
  },
  {
    name: 'EBGaramond-Regular',
    value: 'CartxEBGaramondRegular',
    original: false
  },
  {
    name: 'Futura-Medium',
    value: 'CartxFuturaMedium',
    original: false
  },
  {
    name: 'LibreFranklin-Regular',
    value: 'CartxLibreFranklinRegular',
    original: false
  },
  {
    name: 'Lora-Regular',
    value: 'CartxLoraRegular',
    original: false
  },
  {
    name: 'Montserrat-Regular',
    value: 'CartxMontserratRegular',
    original: false
  },
  {
    name: 'OpenSans-Regular',
    value: 'CartxOpenSansRegular',
    original: false
  },
  {
    name: 'PT_Sans-Narrow-Web-Regular',
    value: 'CartxPTSansNarrowWebRegular',
    original: false
  },
  {
    name: 'Raleway-Regular',
    value: 'CartxRalewayRegular',
    original: false
  },
  {
    name: 'Roboto-Condensed',
    value: 'CartxRobotoCondensed',
    original: false
  },
  {
    name: 'NotoSansJP-Regular',
    value: 'CartxNotoSansJPRegular',
    original: false
  },
  {
    name: 'NotoSerifJP-Regular',
    value: 'CartxNotoSerifJPRegular',
    original: false
  }
];

export const predefineColors = [
  '#ff4500',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585',
  '#f1b859',
  '#f4994b',
  '#d7394d',
  '#dd5b46',
  '#f7d69e',
];
export const shortFormAddList = [{
    label: "Email",//,名称
    necessary : true, //是否必填
    placeholder: "Email Address",//输入框提示文本
    type: "Email",//校验input所用字段
    attribute: "Email",//校验input所用字段
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'Phone Number',//,名称
    necessary : true, //是否必填
    placeholder: "Phone Number",//输入框提示文本
    type: "Mobile Number",//校验input所用字段
    attribute: "Mobile Number",//
    phoneCountryAbbreviation: 'US',
    enablePrivacyCheck:false,
    enablePrivacyCheckValue:'on',
    phoneCode: '+1',
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  }
]
export const formAddList = [
  {
    label: "Email",//,名称
    necessary : true, //是否必填
    placeholder: "Email Address",//输入框提示文本
    type: "Email",//校验input所用字段
    attribute: "Email",//校验input所用字段
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'Phone Number',//,名称
    necessary : true, //是否必填
    placeholder: "Phone Number",//输入框提示文本
    type: "Mobile Number",//校验input所用字段
    attribute: "Mobile Number",//
    phoneCountryAbbreviation: 'US',
    enablePrivacyCheck:false,
    enablePrivacyCheckValue:'on',
    phoneCode: '+1',
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'Birthday',//,名称
    necessary : false, //是否必填
    placeholder: "Birthday",//输入框提示文本
    type: "Birthday",//校验input所用字段
    attribute: "Birthday",//
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'First Name',//,名称
    necessary : false, //是否必填
    placeholder: "First Name",//输入框提示文本
    type: "First Name",//校验input所用字段
    attribute: "First Name",//
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'Last Name',//,名称
    necessary : false, //是否必填
    placeholder: "Last Name",//输入框提示文本
    type: "Last Name",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"Last Name"//属性
  },
  {
    label: 'Country',//,名称
    necessary : false, //是否必填
    placeholder: "Country",//输入框提示文本
    type: "Country",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"Country"//属性
  },

  {
    label: 'Province',//,名称
    necessary : false, //是否必填
    placeholder: "Province",//输入框提示文本
    type: "Province",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"Province"//属性
  },
  {
    label: 'City',//,名称
    necessary : false, //是否必填
    placeholder: "City",//输入框提示文本
    type: "City",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"City"//属性
  },
  {
    label: '自定义',//,名称
    necessary : true, //是否必填
    type: "自定义",//校验input所用字段
    max: 100,
    routine : false, //和自定义区别的 是否是常规字段
    optionList: [
      {},
    ],
    questionType:'Single',//单选多选
    question:'',//问题名称
    attributeId:undefined,
    attribute:''//属性
  },
];

export const countdownTimeOption = [
  {label:'分钟',value:"minute"},
  {label:'秒',value:"second"},
];

export const borderRadiusOptions = [
  {name: '0', value: '0'},
  {name: '4', value: '4px'},
  {name: '8', value: '8px'},
  {name: '16', value: '16px'},
  {name: '全圆角', value: '1000px'}, // 不能设置50%， 会变成椭圆
];

export const borderStyleOptions = [
  {name: '无', value: 'none'},
  {name: '实线', value: 'solid'},
  {name: '虚线', value: 'dashed'},
];
export const typesettingOptions = [
  {name: '左图', value: 'left'},
  {name: '右图', value: 'right'},
  {name: '上图', value: 'top'},
  {name: '中图', value: 'middle'},
  {name: '背景图', value: 'background'},
  {name: '无图', value: 'none'},
];

export const typesettingOptions1 = [
  {name: '左图', value: 'left'},
  {name: '右图', value: 'right'},
  {name: '上图', value: 'top'},
  {name: '中图', value: 'middle'},
]

export const fontSizeOptions = ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '21px', '22px', '23px', '24px', '25px', '26px', '27px', '28px', '29px', '30px', '31px', '32px', '33px', '34px', '35px', '36px', '37px', '38px', '39px', '40px', '41px', '42px', '43px', '44px', '45px', '46px', '47px', '48px', '49px', '50px'];

export const backgroundOptions = [
  {value: 'none', name: '无背景'},
  {value: '', name: '有背景'}
]